var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDanger = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.722,
    height: 24.722,
    viewBox: "0 0 24.722 24.722",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M617.36,573.722A12.362,12.362,0,1,1,626.1,570.1,12.279,12.279,0,0,1,617.36,573.722Zm-3.134-17.349h0l-1.749,1.748,3.135,3.134-3.135,3.135,1.749,1.749L617.361,563l3.133,3.134,1.749-1.748-3.134-3.135,3.134-3.134-1.749-1.748-3.134,3.134-3.134-3.134Z",
    transform: "translate(-605 -549)",
    fill: "#fc6a61"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDanger);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/danger.d48a1ad060c1965785d651e2359341bf.svg";